import { useCallback } from "react";

export function useRandomHexColor(): () => string {
  return useCallback(() => {
    const rand = () => Math.floor(Math.random() * 206) + 50;
    return `#${[rand(), rand(), rand()]
      .map((n) => n.toString(16).padStart(2, "0"))
      .join("")}`;
  }, []);
}